import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Placeholder from 'flarum/common/components/Placeholder';
import { loadActivity } from '../utils/farmApi.mjs';
import { activityMessage } from '../utils/farmLabels.mjs';
import { mapFarmError, parseFarmTimestamp } from '../utils/farmState.mjs';

export default {
  oninit(vnode) {
    this.page = 1;
    this.rows = [];
    this.hasMore = false;
    this.loading = true;
    this.error = '';
    this.load(vnode);
  },
  load(vnode, append = false) {
    this.loading = true;
    return loadActivity(vnode.attrs.app, { page: this.page }, vnode.attrs.basePath)
      .then((response) => { const data = response?.data || response || {}; this.rows = append ? this.rows.concat(data.rows || []) : (data.rows || []); this.hasMore = Boolean(data.hasMore); })
      .catch((error) => { this.error = mapFarmError(error); })
      .finally(() => { this.loading = false; m.redraw(); });
  },
  view(vnode) {
    return (
      <section className="YingtaoFarmPanel" aria-labelledby="yingtao-activity-title">
        <header className="YingtaoFarmPanel-header"><h2 id="yingtao-activity-title">农场动态</h2></header>
        {this.error ? <div className="Alert Alert--error" role="alert">{this.error}</div> : null}
        {this.loading && !this.rows.length ? <LoadingIndicator /> : null}
        {!this.loading && !this.rows.length ? <Placeholder text="还没有农场动态。" /> : null}
        {this.rows.length ? <ol className="YingtaoActivityList">{this.rows.map((row, index) => <li key={row.id || index}>{row.message || activityMessage(row)}{row.createdAt ? <time>{new Date(parseFarmTimestamp(row.createdAt)).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai', hour12: false })}</time> : null}</li>)}</ol> : null}
        {this.hasMore ? <Button className="Button Button--link" loading={this.loading} onclick={() => { this.page += 1; this.load(vnode, true); }}>加载更多</Button> : null}
      </section>
    );
  },
};
